export default __webpack_public_path__ + "static/medicina-mobile-76201b4028963c01310d9c8a3420c378.svg";